import { groupArray } from '~/utils'
import { commonAreas } from '~/data'
import React, { useRef, useState } from 'react'
import { Lazyload, Button, Lightbox, Modal } from '~/components'
import { Image } from '~/components/Lightbox'
import * as st from '~/assets/styl/CommonAreas.module.styl'
import * as stLoc from '~/assets/styl/Location.module.styl'
import * as stDorm from '~/assets/styl/Dormitories.module.styl'
import Slider, { SliderRef, ArrowType } from '@fil1pe/react-slider'
import cn from 'classnames'
import img from '~/assets/img/area-kids-cercada.webp'
import imgSection from '~/assets/img/patio-areas-comuns.webp'
import { useLanguage } from '~/hooks'

export default function Dormitories() {
  const slider = useRef<SliderRef>()
  const [index, setIndex] = useState(0)
  const [images, setImages] = useState<Array<Image>>()
  const zoom = () =>
    setImages(
      commonAreas.flatMap(({ items }, index) =>
        items.map(({ image }, _index) => ({
          url: image,
          legend: t('CommonAreasData.names', { returnObjects: true })[index][
            _index
          ].name,
        }))
      )
    )

  const [modal, setModal] = useState(-1)
  const { t } = useLanguage()
  return (
    <>
      <section className={st.core1}>
        <div>
          <h2>
            <span>
              {t('CommonAreas.title.1')}
              <br />
              {t('CommonAreas.title.2')}
              <br />
              {t('CommonAreas.title.3')}
            </span>
          </h2>
          <ul>
            <li>{t('CommonAreas.areas.item1')}</li>
            <li>{t('CommonAreas.areas.item2')}</li>
            <li>{t('CommonAreas.areas.item3')}</li>
            <li>{t('CommonAreas.areas.item4')}</li>
            <li>{t('CommonAreas.areas.item5')}</li>
            <li>{t('CommonAreas.areas.item6')}</li>
            <li>{t('CommonAreas.areas.item7')}</li>
          </ul>
        </div>
        <div>
          <Lazyload src={img} className={st.img} />
          <div className={st.text}>
            <h3>{t('CommonAreas.subtitle')}</h3>
            <Button href="/#AreasComuns">
              {t('CommonAreas.knowCommonAreas')}
            </Button>
          </div>
        </div>
      </section>

      <Lazyload src={imgSection} type="section" className={st.imgSection} />

      <section id="AreasComuns" className={st.core2}>
        <Slider
          ref={slider}
          renderArrow={({ className, ...props }, type) => (
            <button
              {...props}
              className={cn(className, st.arrow, {
                [st.next]: type === ArrowType.Next,
              })}
            ></button>
          )}
          pagination={1}
          onSlideChange={setIndex}
          className={st.slider}
        >
          {commonAreas.map(({ items }, index) =>
            items.map(({ thumbnail }, _index) => (
              <Lazyload
                src={thumbnail}
                key={_index}
                className={st.slide}
                onClick={zoom}
              >
                <span>
                  {
                    t('CommonAreasData.names', { returnObjects: true })[index][
                      _index
                    ].name
                  }
                </span>
              </Lazyload>
            ))
          )}
        </Slider>

        <div className={st.selector}>
          {commonAreas.map(({ items: areaItems }, index) => (
            <div key={index}>
              <h3>
                {
                  t('CommonAreasData.title', { returnObjects: true })[index]
                    .name
                }
              </h3>
              <ul>
                {areaItems.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <button
                      onClick={() => {
                        const cumulativeIndex =
                          commonAreas
                            .slice(0, index)
                            .reduce((acc, curr) => acc + curr.items.length, 0) +
                          itemIndex
                        setIndex(cumulativeIndex)
                        slider.current?.slickGoTo(cumulativeIndex)
                        zoom()
                      }}

                      /* className={ st.active : null} */
                    >
                      {
                        t('CommonAreasData.names', { returnObjects: true })[
                          index
                        ][itemIndex].name
                      }
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className={st.links}>
          <Button onClick={() => setModal(0)} outlined>
            {t('CommonAreas.tecnicButton')}
          </Button>
          <Button href="/#FaleConosco">{t('CommonAreas.buttonContact')}</Button>
        </div>
      </section>

      <Lightbox
        index={index}
        setIndex={setIndex}
        images={images}
        setImages={setImages}
      />

      <Modal
        open={modal === 0}
        onClose={() => setModal(-1)}
        className={stLoc.modal}
      >
        {(closeProps) => (
          <>
            <button {...closeProps}></button>
            <h3>{t('CommonAreas.differentials')}</h3>
            <ul className={stDorm.modalList}>
              <li>{t('CommonAreas.list.item1')}</li>
              <li>{t('CommonAreas.list.item2')}</li>
              <li>{t('CommonAreas.list.item3')}</li>
              <li>{t('CommonAreas.list.item4')}</li>
              <li>{t('CommonAreas.list.item5')}</li>
              <li>{t('CommonAreas.list.item6')}</li>
              <li>{t('CommonAreas.list.item7')}</li>
              <li>{t('CommonAreas.list.item8')}</li>
              <li>{t('CommonAreas.list.item9')}</li>
              <li>{t('CommonAreas.list.item10')}</li>
              <li>{t('CommonAreas.list.item11')}</li>
              <li>{t('CommonAreas.list.item12')}</li>
              <li>{t('CommonAreas.list.item13')}</li>
              <li>{t('CommonAreas.list.item14')}</li>
              <li>{t('CommonAreas.list.item15')}</li>
              <li>{t('CommonAreas.list.item16')}</li>
              <li>{t('CommonAreas.list.item17')}</li>
              <li>{t('CommonAreas.list.item18')}</li>
              <li>{t('CommonAreas.list.item19')}</li>
              <li>{t('CommonAreas.list.item20')}</li>
            </ul>
          </>
        )}
      </Modal>
    </>
  )
}
